import { Fade } from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { ReactComponent as Fechar } from "../../../assets/icons/fechar.svg";

import { TextsProps } from "../../../database/txt.interface";
import { UserProps } from "../../../interfaces/pacientes.interface";
import { AddPacAvalActions } from "../../../store/ducks/add_pac_aval";
import { AppActions } from "../../../store/ducks/app";
import { TypesErrorRequest } from "../../../utils/types";
import FotoPerfilMenor from "../../FotoPerfilMenor";
import ToastAlert from "../../toast";
import { ConteinerModal } from "./styles";
import { AmplitudeLog } from "../../../utils/amplitude";

import { formatDominantForSave } from "../../../utils/funcs";
import Form from "../../../components/Form";
import InputTextEntryForm from "../../../components/Inputs/inputForm";
import InputSelectForm from "../../SelectComponent/InputSelectForm";
import { FormHandles } from "@unform/core";
import FormSubmiteButton from "../../Buttons/FormSubmitButton";
import { useDataSubscription } from "../../../hooks/useDataSubscription";
import { useLoadPatientSelectOptions } from "./useLoadPatientSelectOptions";

const VALE_SUBSCRIPTION_USER_ID = 99213;

interface Usuario {
	celular: string;
	cpf: string;
}

const AdicionarPaciente = () => {
	const dispatch = useDispatch();
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const is_open = useSelector(
		(state: any) => state.app.is_open_adicionar_paciente
	);
	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);
	const load = useSelector(
		(state: any) => state.app.load_new_evaluator_or_patient
	);

	const management = useSelector((state: any) => state.dashboard.gerencias);

	const entrance_door_data = useSelector(
		(state: any) => state.dashboard.entrance_door_data
	);

	const positionsDynalabs = useSelector((state: any) => state.dashboard.cargos);

	const [steps, setSteps] = useState(0);

	const [entranceDoorList, setEntranceDoorList] = useState([]);
	const [managementList, setManagementList] = useState([]);
	const [positionList, setPositionList] = useState([]);

	const ModalAdicionarPacienteClose = () => {
		dispatch(AppActions.set_modal_adicionar_paciente(false));
		setSteps(0);
		dispatch(AddPacAvalActions.set_avatar_eval_64(null));
		dispatch(AddPacAvalActions.set_avatar_paci_64(null));
		dispatch(AppActions.set_load_add_evaluator_or_patient(false));
		methods.clearErrors();
	};

	const user_logado: UserProps = useSelector((state: any) => state.auth.user);
	const photo = useSelector((state: any) => state.add_pac_aval.photo);

	const isWorklabActive =
		user_logado?.USUARIO_NIVEL == "1" &&
		config_servicos?.SERVICO_DYNALAB == true;

	const { userId } = useDataSubscription();

	const isVale = userId === VALE_SUBSCRIPTION_USER_ID;
	const shouldShowWorklabFields = isWorklabActive || isVale;

	const methods = useForm();

	const formRef = useRef<FormHandles>(null);

	const isStepValid = () => {
		if (steps === 0) {
			const { nome, nascimento } = methods.getValues();
			return Boolean(nome?.trim()) && Boolean(nascimento?.trim());
		} else if (steps === 2) {
			const { sexo } = methods.getValues();
			return Boolean(sexo?.trim());
		} else if (steps === 1) {
			const { EditEntranceDoor } = methods.getValues();
			return isVale ? Boolean(EditEntranceDoor?.trim()) : true;
		}
		return false;
	};

	useEffect(() => {
		isStepValid();
	}, [methods.watch()]);

	useLoadPatientSelectOptions(is_open);

	useEffect(() => {
		if (management?.length > 0) {
			const managementName = management?.map(
				(item: any) => item?.GERENCIA_TITULO
			);
			setManagementList(managementName);
		}

		if (entrance_door_data?.length > 0) {
			const doorList = entrance_door_data?.map(
				(item: any) => item?.PORTA_ENTRADA_TITULO
			);
			setEntranceDoorList(doorList);
		}

		if (positionsDynalabs?.length > 0) {
			const positionDynalabsList = positionsDynalabs?.map(
				(item: any) => item?.CARGO_TITULO
			);

			setPositionList(positionDynalabsList);
		}
	}, [management, entrance_door_data, positionsDynalabs]);

	const onSubmit = () => {
		const findManagementOnList = management?.find(
			(item: any) =>
				item?.GERENCIA_TITULO == methods.getValues("EditManagement")
		);

		const findEntrancedoorOnList = entrance_door_data?.find(
			(item: any) =>
				item?.PORTA_ENTRADA_TITULO == methods.getValues("EditEntranceDoor")
		);

		const findPositionOnList = positionsDynalabs?.find(
			(item: any) => item?.CARGO_TITULO == methods.getValues("EditPosition")
		);

		console.log(methods.getValues(), "values");
		console.log(methods.getValues().nascimento, "values");

		const dat_request = {
			USUARIO_NIVEL: "3",
			USUARIO_NOME: methods.getValues("nome"),
			USUARIO_EMAIL: methods.getValues("email"),
			USUARIO_CONTATO: methods.getValues("celular"),
			USUARIO_FOTO: photo,
			USUARIO_CPF: methods.getValues("cpf"),
			USUARIO_ESTATURA: methods.getValues("altura"),
			USUARIO_MASSA: methods.getValues("massa"),
			USUARIO_NASCIMENTO:
				current_language?.idioma === "Português"
					? methods.getValues("nascimento")?.split("/").reverse().join("-")
					: current_language?.idioma === "English"
					? `${methods.getValues("nascimento")?.substr(6, 10)}-${methods
							.getValues("nascimento")
							?.substr(0, 5)
							.split("/")
							.reverse()
							.join("-")}`
					: methods.getValues("nascimento").split("-").reverse().join("-"),
			USUARIO_SEXO: methods.getValues("sexo") == "Masculino" ? "M" : "F",
			USUARIO_CONDICIONAMENTO: methods.getValues("condicionamento"),
			USUARIO_LADO_DOMINANTE:
				!methods.getValues("LadoDominanteSup") ||
				methods.getValues("LadoDominanteSup") ===
					current_language?.lado_dominante_superiores
					? ""
					: formatDominantForSave(
							methods.getValues("LadoDominanteSup"),
							current_language
					  ),
			USUARIO_LADO_DOMINANTE_INFERIOR:
				!methods.getValues("LadoDominanteInf") ||
				methods.getValues("LadoDominanteInf") ===
					current_language?.lado_dominante_inferiores
					? ""
					: formatDominantForSave(
							methods.getValues("LadoDominanteInf"),
							current_language
					  ),
			ID_PORTA_ENTRADA: findEntrancedoorOnList
				? findEntrancedoorOnList?.ID_PORTA_ENTRADA
				: methods.getValues("EditEntranceDoor"),
			USUARIO_MATRICULA: methods.getValues("EditMatricula"),
			ID_GERENCIA: findManagementOnList
				? findManagementOnList?.ID_GERENCIA
				: methods.getValues("EditManagement"),
			ID_CARGO: findPositionOnList
				? findPositionOnList?.ID_CARGO
				: methods.getValues("EditPosition"),
		};

		dispatch(AddPacAvalActions.request_add_user(dat_request));
		dispatch(AppActions.set_load_add_evaluator_or_patient(true));
		setTimeout(() => {
			dispatch(AppActions.set_load_add_evaluator_or_patient(false));
		}, 1000);
	};

	useEffect(() => {
		if (is_open) {
			dispatch(AppActions.clear_toast_visible());
		}
		if (!is_open) {
			methods.reset({
				nome: "",
				nascimento: "",
				cpf: "",
				celular: "",
				email: "",
				massa: "",
				condicionamento: "",
				altura: "",
				sexo: "",
				LadoDominanteSup: "",
				LadoDominanteInf: "",
				EditEntranceDoor: "",
				EditManagement: "",
				EditPosition: "",
				EditMatricula: "",
			});
		}
	}, [is_open]);

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			modal: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			paper: {
				backgroundColor: theme.palette.background.paper,
				border: "0",
				boxShadow: theme.shadows[5],
			},
		})
	);

	const classes = useStyles();

	const is_open_toast = useSelector((state: any) => state.app.is_open_toast);
	const type_toast = useSelector((state: any) => state.app.type_toast);

	useEffect(() => {
		if (type_toast == TypesErrorRequest.SUCCESS) {
			ModalAdicionarPacienteClose();
		}
	}, [is_open_toast]);

	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				onClose={ModalAdicionarPacienteClose}
				open={is_open}
				closeAfterTransition
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={is_open}>
					<ConteinerModal>
						{is_open_toast && type_toast == TypesErrorRequest.FAIL ? (
							<ToastAlert />
						) : (
							""
						)}
						<div className={`flex w-full justify-end `}>
							<Fechar
								className={`w-[18px] h-[18px] cursor-pointer mt-5`}
								onClick={() => {
									ModalAdicionarPacienteClose();
									AmplitudeLog("fechar_modal_novo_paciente");
								}}
							/>
						</div>
						<div className={`flex flex-col w-full items-center justify-center`}>
							<p className={`font-bold text-[#000E4B] text-2xl`}>
								Adicionar Paciente
							</p>
							<div className={`w-auto self-center`}>
								<FotoPerfilMenor />
							</div>
						</div>

						{
							<Form
								methods={methods}
								ref={formRef}
								onSubmit={() => undefined}
								className={`flex flex-col w-full h-full relative mt-3 }`}
							>
								<div style={{ display: steps === 0 ? "flex" : "none" }}>
									<div className={`w-full flex flex-row`}>
										<div className={` flex flex-col w-1/2  `}>
											<InputTextEntryForm
												type="text"
												width={95}
												title={"Nome completo" + "*"}
												placeholder={current_language?.placeholder_digite}
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												marginTop={20}
												typeInputName="nome"
											/>
											<InputTextEntryForm
												type="text"
												width={95}
												title={"Data de nascimento" + "*"}
												placeholder={"dd/mm/aaaa"}
												leftIcon="Calendar"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												marginTop={20}
												typeInputName="nascimento"
											/>
											<InputTextEntryForm
												type="text"
												width={100}
												title={"CPF"}
												placeholder={"__.____-__"}
												leftIcon="DigitalIcon"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												marginTop={20}
												typeInputName="cpf"
											/>
										</div>
										<div className={` flex flex-col w-1/2`}>
											<InputTextEntryForm
												type="text"
												width={100}
												title={"Celular"}
												placeholder={"(DDD) 99999-9999"}
												leftIcon="Phone"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												marginTop={20}
												typeInputName="celular"
											/>
											<InputTextEntryForm
												type="text"
												width={100}
												title={"E-mail"}
												placeholder={"Digite"}
												leftIcon="EmailIcon"
												fontFamily="NotoSans-SemiBold"
												fontWeight={600}
												marginTop={20}
												typeInputName="email"
											/>
										</div>
									</div>
								</div>

								<div style={{ display: steps === 1 ? "flex" : "none" }}>
									<div className={`w-full flex flex-col`}>
										<InputSelectForm
											type="select"
											width={95}
											title={
												isVale
													? current_language?.porta_entrada + "*"
													: current_language?.porta_entrada
											}
											placeholder={"Selecione"}
											rightIcon="ArrowSelect"
											arrayOptions={entranceDoorList}
											fontFamily="NotoSans-SemiBold"
											fontSize={1}
											marginTop={10}
											typeInputName="EditEntranceDoor"
										/>

										<InputSelectForm
											type="select"
											width={95}
											title={current_language?.gerencia}
											placeholder={"Selecione"}
											rightIcon="ArrowSelect"
											arrayOptions={managementList}
											fontFamily="NotoSans-SemiBold"
											fontSize={1}
											marginTop={10}
											typeInputName="EditManagement"
										/>

										<InputSelectForm
											type="select"
											width={95}
											title={current_language?.cargo}
											placeholder={"Selecione"}
											rightIcon="ArrowSelect"
											arrayOptions={positionList}
											fontFamily="NotoSans-SemiBold"
											fontSize={1}
											marginTop={10}
											typeInputName="EditPosition"
										/>

										<InputTextEntryForm
											type="text"
											width={95}
											title={current_language?.matricula}
											placeholder={current_language?.placeholder_digite}
											fontFamily="NotoSans-SemiBold"
											fontWeight={600}
											marginTop={20}
											typeInputName="EditMatricula"
										/>
									</div>
								</div>

								<div style={{ display: steps === 2 ? "flex" : "none" }}>
									<div className={`flex flex-col w-full`}>
										<div className={`flex flex-row w-full`}>
											<div className={` flex flex-col w-1/2 `}>
												<InputTextEntryForm
													type="text"
													width={95}
													title={"Massa"}
													placeholder={"0 m"}
													leftIcon="Mass"
													fontFamily="NotoSans-SemiBold"
													fontWeight={600}
													typeInputName="massa"
												/>

												<InputSelectForm
													type="select"
													width={95}
													title={"Nível de condicionamento"}
													placeholder={"Selecione"}
													rightIcon="ArrowSelect"
													arrayOptions={[
														"Atleta",
														"Ativo",
														"Pós-operatório",
														"Sedentário",
													]}
													fontFamily="NotoSans-SemiBold"
													fontSize={1}
													marginTop={10}
													typeInputName="condicionamento"
												/>
											</div>
											<div className={` flex flex-col w-1/2 `}>
												<InputTextEntryForm
													type="text"
													width={100}
													title={"Altura"}
													placeholder={"0 m"}
													leftIcon="Height"
													fontFamily="NotoSans-SemiBold"
													fontWeight={600}
													typeInputName="altura"
												/>
												<InputSelectForm
													type="select"
													width={100}
													title={"Sexo*"}
													placeholder={"Selecione"}
													rightIcon="ArrowSelect"
													arrayOptions={["Masculino", "Feminino"]}
													fontSize={1}
													fontFamily="NotoSans-SemiBold"
													marginTop={10}
													marginRightIcon={14}
													typeInputName="sexo"
												/>
											</div>
										</div>

										<InputSelectForm
											type="select"
											width={100}
											title={"Lado dominante de membros superiores (opcional)"}
											placeholder={"Selecione"}
											rightIcon="ArrowSelect"
											arrayOptions={["Canhoto", "Destro"]}
											fontFamily="NotoSans-SemiBold"
											fontSize={1}
											marginTop={10}
											description={
												"Escolha qual é o lado da mão que usa para escrever."
											}
											typeInputName="LadoDominanteSup"
										/>
										<InputSelectForm
											type="select"
											width={100}
											title={"Lado dominante de membros inferiores (opcional)"}
											placeholder={"Selecione"}
											rightIcon="ArrowSelect"
											arrayOptions={["Canhoto", "Destro"]}
											fontFamily="NotoSans-SemiBold"
											fontSize={1}
											marginTop={10}
											typeInputName="LadoDominanteInf"
											description={
												"Escolha qual é o lado da perna que tem maior força."
											}
										/>
									</div>
								</div>
								<div className={`flex w-full  absolute bottom-3 `}>
									<FormSubmiteButton
										type="button"
										onClick={() => {
											if (steps === 0) {
												if (shouldShowWorklabFields) {
													setSteps(1);
												} else {
													setSteps(2);
												}
											} else if (steps === 1) {
												setSteps(2);
											} else if (steps === 2) {
												onSubmit();
											}
										}}
										disabled={isStepValid() ? false : true}
										marginTop={4}
										fontFamily="Kanit-Medium"
										typeButtonComponent="primary"
										title={steps !== 2 ? "Avançar" : "Salvar"}
										activityIndicator={load}
										activityIndicatorColor="#63677A"
									/>
								</div>
							</Form>
						}
					</ConteinerModal>
				</Fade>
			</Modal>
		</div>
	);
};

export default AdicionarPaciente;
